import { render, staticRenderFns } from "./MaydayWebProductSolutionsCard.vue?vue&type=template&id=2110b4d5&scoped=true&"
import script from "./MaydayWebProductSolutionsCard.vue?vue&type=script&lang=js&"
export * from "./MaydayWebProductSolutionsCard.vue?vue&type=script&lang=js&"
import style0 from "./MaydayWebProductSolutionsCard.vue?vue&type=style&index=0&id=2110b4d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2110b4d5",
  null
  
)

export default component.exports